/* eslint-disable no-unused-vars */

export const getNoCacheUrl = (url: string) => {
  const noCacheTag = `no-cache-tag=${new Date().getTime()}`;
  if (url.includes('?')) {
    return `${url}&${noCacheTag}`;
  }
  return `${url}?${noCacheTag}`;
};

class UrlData {
  private queryParams: { name: string; value: any }[] = [];

  private url = '';

  private noCache?: boolean;

  constructor(url: string, noCache?: boolean) {
    this.url = url;
    this.noCache = noCache;
  }

  addQueryParam(name: string, value: any): UrlData {
    this.queryParams.push({ name, value });
    return this;
  }

  addQueryParamMany(name: string, values: any[]): UrlData {
    values.forEach((value) => this.queryParams.push({ name, value }));
    return this;
  }

  toStringUrl(): string {
    const params = this.queryParams.map((param) =>
      param.value ? `${param.name}=${param.value}` : ''
    );
    const urlResult = `${this.url}${
      params.length > 0 ? `?${params.join('&')}` : ''
    }`;
    return this.noCache ? getNoCacheUrl(urlResult) : urlResult;
  }
}
export const createUrl = (baseUrl: string, noCache?: boolean): UrlData =>
  new UrlData(baseUrl, noCache);
